export const extra = {
  paddingLeft: 10,
  paddingRight: 10,
  paddingTop: 3,
  paddingBottom: 3,
  background: 'red',
} as React.CSSProperties;

export const sidebarOpenButton = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'flex-end',
  position: 'absolute',
  bottom: 0,
  marginRight: -12,
  marginBottom: 16,
  width: 30,
  height: 30,
  borderRadius: 15,
  zIndex: 5,
} as React.CSSProperties;

export const subItem = {
  background: 'var(--primary-color)',
  marginTop: 0,
  marginBottom: 2,
  fontWeight: 700,
  paddingLeft: 14,
  paddingRight: 14,
  display: 'flex',
  alignItems: 'center',
} as React.CSSProperties;

export const activeSubItem = {
  background: 'linear-gradient(180deg, var(--ete-primary-green-color) 4.94%, #414141 93.83%)',
  marginTop: 0,
  marginBottom: 2,
  fontWeight: 700,
  paddingLeft: 14,
  paddingRight: 14,
  display: 'flex',
  alignItems: 'center',
} as React.CSSProperties;

export const collapsedMenu = {
  padding: '0 calc(50% - 28px / 2)',
};

export const historySubMenu = {
  backgroundColor: 'var(--primary-color)',
  marginTop: 'auto',
  fontWeight: 700,
} as React.CSSProperties;

export const allPPMReadPermissions = [28001, 29001, 30001, 31001, 32001, 33001, 37001, 38001, 54001];

export const allODC2MReadPermissions = [43001, 44001, 45001, 46001, 47001, 48001, 49001, 50001, 51001];

export const allOMMPermissions = [11000, 11001, 11002, 11003, 18001];

export const allFMMPermissions = [
  5000, 5001, 5002, 5003, 6000, 6001, 6002, 6003, 7000, 7001, 7002, 7003, 8000, 8001, 8002, 8003, 9000, 9001, 9002,
  9003, 10000, 10001, 10002, 10003, 19000, 19001, 19002, 19003, 20000, 20001, 20002, 20003, 35000, 35001, 35002, 35003,
  36000, 36001, 36002, 36003,
];

export const allRLSMPermissions = [
  15000, 15001, 15002, 15003, 16000, 16001, 16002, 16003, 23000, 23001, 23002, 23003, 39000, 39001, 39002, 39003, 40000,
  40001, 40002, 40003,
];

export const allExperimentationPermissions = [17000, 17001, 17002, 17003, 34000, 34001, 34002, 34003];

export const allLILLPermissions = [21000, 21001, 21002, 21003];

export const allSSMPermissions = [25000, 25001, 25002, 25003, 26000, 26001, 26002, 26003, 27000, 27001, 27002, 27003];

export const allPPMPermissions = [
  28000, 28001, 28002, 28003, 29000, 29001, 29002, 29003, 30000, 30001, 30002, 30003, 31000, 31001, 31002, 31003, 32000,
  32001, 32002, 32003, 33000, 33001, 33002, 33003, 37000, 37001, 37002, 37003, 38000, 38001, 38002, 38003, 54000, 54001,
  54002, 54003,
];

export const allODC2MPermissions = [
  43000, 43001, 43002, 43003, 44000, 44001, 44002, 44003, 45000, 45001, 45002, 45003, 46000, 46001, 46002, 46003, 47000,
  47001, 47002, 47003, 48000, 48001, 48002, 48003, 49000, 49001, 49002, 49003, 50000, 50001, 50002, 50003, 51000, 51001,
  51002, 51003,
];

export const allCOAMReadPermissions = [55001, 56001, 57001, 58001];

export const allCOAMPermissions = [
  55000, 55001, 55002, 55003, 56001, 56002, 57000, 57001, 57002, 57003, 58000, 58001, 58002, 58003,
];
